/**
 * if the price component already has the tax component in it, we can use this function to get the actual base base price without the tax
 */
export const getActualBasePrice = (price: number, taxPercentage: number) => {
    return (price * 100) / (100 + taxPercentage);
};
